import React from 'react';
import { Container, Button, Link } from 'react-floating-action-button';
import 'font-awesome/css/font-awesome.min.css';

export default function Navbutton() {

    return (
        <Container styles={{ right: "2vw", bottom: "5vh" } }>
            <Link href="/"
                styles={{ backgroundColor: "#F4981D", color: "#FFFFFF" }}
                icon="fa fa-home" />
            <Link href="/faq"
                styles={{ backgroundColor: "#F4981D", color: "#FFFFFF" }}
                icon="fa fa-question" />
            <Button
                className="fab-item text-white"
                styles={{ backgroundColor: "#F4981D", color: "#FFFFFF" }}
                icon="fa fa-bars"/>
        </Container>
    );

}
